// src/protocols.js
//
// RFCs have no explicit "protocol" field in the official index. We derive a
// protocol/topic tag by matching the RFC title against a dictionary of known
// protocols. Order matters: more specific patterns come first (HTTPS before
// HTTP, TLS before generic IP), and the first match wins.
//
// RFCs with no match are tagged "Other".

const PROTOCOLS = [
    ['HTTP', /\bHTTPS?\b|Hypertext Transfer/i],
    ['TLS/SSL', /\bTLS\b|\bSSL\b|Transport Layer Security|Datagram Transport/i],
    ['DNS', /\bDNS\b|Domain Name/i],
    ['QUIC', /\bQUIC\b/i],
    ['BGP', /\bBGP\b|Border Gateway/i],
    ['OSPF', /\bOSPF\b/i],
    ['MPLS', /\bMPLS\b/i],
    ['TCP', /\bTCP\b|Transmission Control/i],
    ['UDP', /\bUDP\b/i],
    ['SMTP', /\bSMTP\b|Mail Transfer/i],
    ['IMAP', /\bIMAP\b/i],
    ['POP', /\bPOP3?\b/i],
    ['MIME', /\bMIME\b/i],
    ['FTP', /\bFTP\b|File Transfer/i],
    ['SIP', /\bSIP\b|Session Initiation/i],
    ['RTP', /\bRTP\b|Real-time Transport/i],
    ['SSH', /\bSSH\b|Secure Shell/i],
    ['SNMP', /\bSNMP\b/i],
    ['LDAP', /\bLDAP\b/i],
    ['DHCP', /\bDHCP\b|Dynamic Host/i],
    ['NTP', /\bNTP\b|Network Time/i],
    ['OAuth', /OAuth/i],
    ['ICMP', /\bICMP\b/i],
    ['IPsec', /\bIPsec\b/i],
    ['IPv6', /\bIPv6\b/i],
    ['IP', /\bIP\b|Internet Protocol/i],
    ['URI/URL', /\bURI\b|\bURL\b|Uniform Resource/i],
    ['Email', /\b(e-?mail|message format)\b/i],
];

/** Return the protocol tag for an RFC, or 'Other' if none match. */
export function detectProtocol(rfc) {
    const title = rfc?.data?.title || '';
    for (const [name, re] of PROTOCOLS) {
        if (re.test(title)) return name;
    }
    return 'Other';
}

/**
 * Count RFCs per protocol, return sorted [{ name, count }] descending.
 * 'Other' is forced to the end.
 */
export function protocolCounts(rfcs) {
    const counts = new Map();
    for (const rfc of rfcs) {
        const p = detectProtocol(rfc);
        counts.set(p, (counts.get(p) || 0) + 1);
    }
    return [...counts.entries()]
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => {
            if (a.name === 'Other') return 1;
            if (b.name === 'Other') return -1;
            return b.count - a.count;
        });
}
